/*eslint-disable no-whitespace-before-property */

class ClaimStatusSummary {
  constructor() {
    this.claimStatusSummary = null;
    this.claimStatusSummaryByProduct = [];
    this.claimStatus = [];
    this.claimStatusByProduct = [];
  }

  getClaimStatusSummary() {
    return this.claimStatusSummary;
  }

  setClaimStatusSummary(claimStatusSummary) {
    this.claimStatusSummary = claimStatusSummary;
  }

  getClaimStatusSummaryByProduct(iIndex) {
    return this.claimStatusSummaryByProduct[iIndex];
  }

  setClaimStatusSummaryByProduct(iIndex, claimStatusSummary) {
    this.claimStatusSummaryByProduct[iIndex] = claimStatusSummary;
  }

  resetClaimStatusSummary() {
    this.claimStatusSummary = null;
    this.claimStatusSummaryByProduct = [];
    this.claimStatus = [];
    this.claimStatusByProduct = [];
  }
}
export default new ClaimStatusSummary();
